import React from "react";
import { Skeleton } from "antd-mobile";
import { useTransition, animated } from "@react-spring/web";
import "./SkeletonScreen.less";
import { isShowOpenBar } from "../../components/open-bar";
import clsx from "clsx";
import { getBrowserEnv } from "@/utils/tools";

interface SkeletonScreenProps {
  visible: boolean;
}

const SkeletonScreen: React.FC<SkeletonScreenProps> = ({ visible }) => {
  const { isXPApp } = getBrowserEnv();
  const transitions = useTransition(visible, {
    from: { opacity: 1 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 300 },
  });

  return transitions((style, item) =>
    item ? (
      <animated.div
        style={{
          ...style,
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 9999,
        }}
      >
        <div className="skeleton-screen">
          {/* 顶部导航栏骨架（新增，贴合页面顶部结构） */}
          {isShowOpenBar && (
            <div className="skeleton-navbar">
              <Skeleton animated className="skeleton-nav-title" />
            </div>
          )}
          {/* VIP等级大卡片骨架（核心区块，保留整体结构） */}
          <div
            className={clsx("skeleton-vip-card", {
              "show-open-bar": isShowOpenBar,
            })}
          >
            <div
              className={clsx("skeleton-vip-card-content", {
                "app-padding-top": isXPApp,
              })}
            >
              <div className="skeleton-user-info">
                <Skeleton animated className="skeleton-avatar" />
                <Skeleton animated className="skeleton-user-details" />
              </div>
              <Skeleton animated className="skeleton-vip-level" />
            </div>
          </div>

          <div className="skeleton-content">
            <div className="skeleton-content-tab">
              <div className="skeleton-content-tab-item">
                <Skeleton.Title
                  animated
                  className="skeleton-content-tab-item-text"
                />
              </div>
              <div className="skeleton-content-tab-item">
                <Skeleton.Title
                  animated
                  className="skeleton-content-tab-item-text"
                />
              </div>
            </div>

            <div className="skeleton-content-big-good">
              <Skeleton animated className="skeleton-content-big-good-item" />
            </div>

            <div className="skeleton-content-goods">
              <div className="skeleton-content-goods-item-wrapper">
                <Skeleton animated className="skeleton-content-goods-item" />
              </div>
              <div className="skeleton-content-goods-item-wrapper">
                <Skeleton animated className="skeleton-content-goods-item" />
              </div>
              <div className="skeleton-content-goods-item-wrapper">
                <Skeleton animated className="skeleton-content-goods-item" />
              </div>
            </div>

            <div className="skeleton-content-good-buy">
              <Skeleton animated className="skeleton-content-good-buy-img" />
              <Skeleton animated className="skeleton-content-good-buy-button" />
              <Skeleton.Title
                animated
                className="skeleton-content-good-buy-info"
              />
            </div>
          </div>

          <div className="skeleton-good-single-row">
            <Skeleton animated className="skeleton-content-good-single-item" />
          </div>
          <div className="skeleton-good-single-row">
            <Skeleton animated className="skeleton-content-good-single-item" />
          </div>
          <div className="skeleton-good-single-row">
            <Skeleton animated className="skeleton-content-good-single-item" />
          </div>

          {/* 底部购买按钮栏（保留核心操作区） */}
          <div className="skeleton-bottom-bar">
            <Skeleton animated className="skeleton-buy-button" />
            <Skeleton animated className="skeleton-agreement-row" />
          </div>
        </div>
      </animated.div>
    ) : null,
  );
};

export default SkeletonScreen;
